import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { ReturnStruct } from '../../structs/return.struct';

@Injectable({
    providedIn: 'root',
})
export class ContasPagarParcelaService extends CommonService {
    private readonly apiUrl: string = environment.urlApiFinancas + 'ContasPagarParcela';

    constructor(private httpClient: HttpClient) {
        super();
    }

    public getById(idContasPagarParcela: number): Observable<any> {
        const url = `${this.apiUrl}/idContasPagarParcela/${idContasPagarParcela}`;
        return this.httpClient
            .get<any>(url, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public update(request: any): Observable<ReturnStruct> {
        return this.httpClient
            .put<ReturnStruct>(this.apiUrl, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public getArquivoContasPagarParcela(urlArquivo: string): Observable<any> {
        const params = new HttpParams().set('urlArquivo', urlArquivo);
        const url = `${this.apiUrl}/getArquivoContasPagarParcela`;
        return this.httpClient
            .get<any>(url, { params, ...this.addHeaderToken() })
            .pipe(catchError(this.handleError));
    }
}
